export const OrganizationHolidayDetailFragment = gql`
  fragment OrganizationHolidayDetailFragment on OrganizationHoliday {
    id
    name
    date
  }
`
